"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const arabicReference = {
    "alef": {
        "normal": [
            "\u0627"
        ],
        "madda_above": {
            "normal": [
                "\u0627\u0653",
                "\u0622"
            ],
            "isolated": "\uFE81",
            "final": "\uFE82"
        },
        "hamza_above": {
            "normal": [
                "\u0627\u0654",
                "\u0623"
            ],
            "isolated": "\uFE83",
            "final": "\uFE84"
        },
        "hamza_below": {
            "normal": [
                "\u0627\u0655",
                "\u0625"
            ],
            "isolated": "\uFE87",
            "final": "\uFE88"
        },
        "wasla": {
            "normal": "\u0671",
            "isolated": "\uFB50",
            "final": "\uFB51"
        },
        "wavy_hamza_above": [
            "\u0672"
        ],
        "wavy_hamza_below": [
            "\u0627\u065F",
            "\u0673"
        ],
        "high_hamza": [
            "\u0675",
            "\u0627\u0674"
        ],
        "indic_two_above": [
            "\u0773"
        ],
        "indic_three_above": [
            "\u0774"
        ],
        "fathatan": {
            "normal": [
                "\u0627\u064B"
            ],
            "final": "\uFD3C",
            "isolated": "\uFD3D"
        },
        "isolated": "\uFE8D",
        "final": "\uFE8E"
    },
    "beh": {
        "normal": [
            "\u0628"
        ],
        "dotless": [
            "\u066E"
        ],
        "three_dots_horizontally_below": [
            "\u0750"
        ],
        "dot_below_three_dots_above": [
            "\u0751"
        ],
        "three_dots_pointing_upwards_below": [
            "\u0752"
        ],
        "three_dots_pointing_upwards_below_two_dots_above": [
            "\u0753"
        ],
        "two_dots_below_dot_above": [
            "\u0754"
        ],
        "inverted_small_v_below": [
            "\u0755"
        ],
        "small_v": [
            "\u0756"
        ],
        "small_v_below": [
            "\u08A0"
        ],
        "hamza_above": [
            "\u08A1"
        ],
        "small_meem_above": [
            "\u08B6"
        ],
        "isolated": "\uFE8F",
        "final": "\uFE90",
        "initial": "\uFE91",
        "medial": "\uFE92"
    },
    "teh marbuta": {
        "normal": [
            "\u0629"
        ],
        "isolated": "\uFE93",
        "final": "\uFE94"
    },
    "teh": {
        "normal": [
            "\u062A"
        ],
        "ring": [
            "\u067C"
        ],
        "three_dots_above_downwards": [
            "\u067D"
        ],
        "small_teh_above": [
            "\u08B8"
        ],
        "isolated": "\uFE95",
        "final": "\uFE96",
        "initial": "\uFE97",
        "medial": "\uFE98"
    },
    "theh": {
        "normal": [
            "\u062B"
        ],
        "isolated": "\uFE99",
        "final": "\uFE9A",
        "initial": "\uFE9B",
        "medial": "\uFE9C"
    },
    "jeem": {
        "normal": [
            "\u062C"
        ],
        "two_dots_above": [
            "\u08A2"
        ],
        "isolated": "\uFE9D",
        "final": "\uFE9E",
        "initial": "\uFE9F",
        "medial": "\uFEA0"
    },
    "hah": {
        "normal": [
            "\u062D"
        ],
        "hamza_above": [
            "\u0681"
        ],
        "two_dots_vertical_above": [
            "\u0682"
        ],
        "three_dots_above": [
            "\u0685"
        ],
        "two_dots_above": [
            "\u0757"
        ],
        "three_dots_pointing_upwards_below": [
            "\u0758"
        ],
        "small_tah_below": [
            "\u076E"
        ],
        "small_tah_two_dots": [
            "\u076F"
        ],
        "small_tah_above": [
            "\u0772"
        ],
        "indic_four_below": [
            "\u077C"
        ],
        "isolated": "\uFEA1",
        "final": "\uFEA2",
        "initial": "\uFEA3",
        "medial": "\uFEA4"
    },
    "khah": {
        "normal": [
            "\u062E"
        ],
        "isolated": "\uFEA5",
        "final": "\uFEA6",
        "initial": "\uFEA7",
        "medial": "\uFEA8"
    },
    "dal": {
        "normal": [
            "\u062F"
        ],
        "ring": [
            "\u0689"
        ],
        "dot_below": [
            "\u068A"
        ],
        "dot_below_small_tah": [
            "\u068B"
        ],
        "three_dots_above_downwards": [
            "\u068F"
        ],
        "four_dots_above": [
            "\u0690"
        ],
        "inverted_v": [
            "\u06EE"
        ],
        "two_dots_vertically_below_small_tah": [
            "\u0759"
        ],
        "inverted_small_v_below": [
            "\u075A"
        ],
        "three_dots_below": [
            "\u08AE"
        ],
        "isolated": "\uFEA9",
        "final": "\uFEAA"
    },
    "thal": {
        "normal": [
            "\u0630"
        ],
        "isolated": "\uFEAB",
        "final": "\uFEAC"
    },
    "reh": {
        "normal": [
            "\u0631"
        ],
        "small_v": [
            "\u0692"
        ],
        "ring": [
            "\u0693"
        ],
        "dot_below": [
            "\u0694"
        ],
        "small_v_below": [
            "\u0695"
        ],
        "dot_below_dot_above": [
            "\u0696"
        ],
        "two_dots_above": [
            "\u0697"
        ],
        "four_dots_above": [
            "\u0699"
        ],
        "inverted_v": [
            "\u06EF"
        ],
        "stroke": [
            "\u075B"
        ],
        "two_dots_vertically_above": [
            "\u076B"
        ],
        "hamza_above": [
            "\u076C"
        ],
        "small_tah_two_dots": [
            "\u0771"
        ],
        "loop": [
            "\u08AA"
        ],
        "small_noon_above": [
            "\u08B9"
        ],
        "isolated": "\uFEAD",
        "final": "\uFEAE"
    },
    "zain": {
        "normal": [
            "\u0632"
        ],
        "inverted_v_above": [
            "\u08B2"
        ],
        "isolated": "\uFEAF",
        "final": "\uFEB0"
    },
    "seen": {
        "normal": [
            "\u0633"
        ],
        "dot_below_dot_above": [
            "\u069A"
        ],
        "three_dots_below": [
            "\u069B"
        ],
        "three_dots_below_three_dots_above": [
            "\u069C"
        ],
        "four_dots_above": [
            "\u075C"
        ],
        "two_dots_vertically_above": [
            "\u076D"
        ],
        "small_tah_two_dots": [
            "\u0770"
        ],
        "indic_four_above": [
            "\u077D"
        ],
        "inverted_v": [
            "\u077E"
        ],
        "isolated": "\uFEB1",
        "final": "\uFEB2",
        "initial": "\uFEB3",
        "medial": "\uFEB4"
    },
    "sheen": {
        "normal": [
            "\u0634"
        ],
        "dot_below": [
            "\u06FA"
        ],
        "isolated": "\uFEB5",
        "final": "\uFEB6",
        "initial": "\uFEB7",
        "medial": "\uFEB8"
    },
    "sad": {
        "normal": [
            "\u0635"
        ],
        "two_dots_below": [
            "\u069D"
        ],
        "three_dots_above": [
            "\u069E"
        ],
        "three_dots_below": [
            "\u08AF"
        ],
        "isolated": "\uFEB9",
        "final": "\uFEBA",
        "initial": "\uFEBB",
        "medial": "\uFEBC"
    },
    "dad": {
        "normal": [
            "\u0636"
        ],
        "dot_below": [
            "\u06FB"
        ],
        "isolated": "\uFEBD",
        "final": "\uFEBE",
        "initial": "\uFEBF",
        "medial": "\uFEC0"
    },
    "tah": {
        "normal": [
            "\u0637"
        ],
        "three_dots_above": [
            "\u069F"
        ],
        "two_dots_above": [
            "\u08A3"
        ],
        "isolated": "\uFEC1",
        "final": "\uFEC2",
        "initial": "\uFEC3",
        "medial": "\uFEC4"
    },
    "zah": {
        "normal": [
            "\u0638"
        ],
        "isolated": "\uFEC5",
        "final": "\uFEC6",
        "initial": "\uFEC7",
        "medial": "\uFEC8"
    },
    "ain": {
        "normal": [
            "\u0639"
        ],
        "three_dots_above": [
            "\u06A0"
        ],
        "two_dots_above": [
            "\u075D"
        ],
        "three_dots_pointing_downwards_above": [
            "\u075E"
        ],
        "two_dots_vertically_above": [
            "\u075F"
        ],
        "three_dots_below": [
            "\u08B3"
        ],
        "isolated": "\uFEC9",
        "final": "\uFECA",
        "initial": "\uFECB",
        "medial": "\uFECC"
    },
    "ghain": {
        "normal": [
            "\u063A"
        ],
        "dot_below": [
            "\u06FC"
        ],
        "isolated": "\uFECD",
        "final": "\uFECE",
        "initial": "\uFECF",
        "medial": "\uFED0"
    },
    "feh": {
        "normal": [
            "\u0641"
        ],
        "dotless": [
            "\u06A1"
        ],
        "dot_moved_below": [
            "\u06A2"
        ],
        "dot_below": [
            "\u06A3"
        ],
        "three_dots_below": [
            "\u06A5"
        ],
        "two_dots_below": [
            "\u0760"
        ],
        "three_dots_pointing_upwards_below": [
            "\u0761"
        ],
        "dot_below_three_dots_above": [
            "\u08A4"
        ],
        "isolated": "\uFED1",
        "final": "\uFED2",
        "initial": "\uFED3",
        "medial": "\uFED4"
    },
    "qaf": {
        "normal": [
            "\u0642"
        ],
        "dotless": [
            "\u066F"
        ],
        "dot_above": [
            "\u06A7"
        ],
        "three_dots_above": [
            "\u06A8"
        ],
        "dot_below": [
            "\u08A5"
        ],
        "isolated": "\uFED5",
        "final": "\uFED6",
        "initial": "\uFED7",
        "medial": "\uFED8"
    },
    "kaf": {
        "normal": [
            "\u0643"
        ],
        "swash": [
            "\u06AA"
        ],
        "ring": [
            "\u06AB"
        ],
        "dot_above": [
            "\u06AC"
        ],
        "three_dots_below": [
            "\u06AE"
        ],
        "two_dots_above": [
            "\u077F"
        ],
        "dot_below": [
            "\u08B4"
        ],
        "isolated": "\uFED9",
        "final": "\uFEDA",
        "initial": "\uFEDB",
        "medial": "\uFEDC"
    },
    "lam": {
        "normal": [
            "\u0644"
        ],
        "small_v": [
            "\u06B5"
        ],
        "dot_above": [
            "\u06B6"
        ],
        "three_dots_above": [
            "\u06B7"
        ],
        "three_dots_below": [
            "\u06B8"
        ],
        "bar": [
            "\u076A"
        ],
        "double_bar": [
            "\u08A6"
        ],
        "isolated": "\uFEDD",
        "final": "\uFEDE",
        "initial": "\uFEDF",
        "medial": "\uFEE0"
    },
    "meem": {
        "normal": [
            "\u0645"
        ],
        "dot_above": [
            "\u0765"
        ],
        "dot_below": [
            "\u0766"
        ],
        "three_dots_above": [
            "\u08A7"
        ],
        "isolated": "\uFEE1",
        "final": "\uFEE2",
        "initial": "\uFEE3",
        "medial": "\uFEE4"
    },
    "noon": {
        "normal": [
            "\u0646"
        ],
        "dot_below": [
            "\u06B9"
        ],
        "ring": [
            "\u06BC"
        ],
        "three_dots_above": [
            "\u06BD"
        ],
        "two_dots_below": [
            "\u0767"
        ],
        "small_tah": [
            "\u0768"
        ],
        "small_v": [
            "\u0769"
        ],
        "isolated": "\uFEE5",
        "final": "\uFEE6",
        "initial": "\uFEE7",
        "medial": "\uFEE8"
    },
    "heh": {
        "normal": [
            "\u0647"
        ],
        "isolated": "\uFEE9",
        "final": "\uFEEA",
        "initial": "\uFEEB",
        "medial": "\uFEEC"
    },
    "waw": {
        "normal": [
            "\u0648"
        ],
        "hamza_above": {
            "normal": [
                "\u0624",
                "\u0648\u0654"
            ],
            "isolated": "\uFE85",
            "final": "\uFE86"
        },
        "high_hamza": [
            "\u0676",
            "\u0648\u0674"
        ],
        "ring": [
            "\u06C4"
        ],
        "two_dots_above": [
            "\u06CA"
        ],
        "dot_above": [
            "\u06CF"
        ],
        "indic_two_above": [
            "\u0778"
        ],
        "indic_three_above": [
            "\u0779"
        ],
        "dot_within": [
            "\u08AB"
        ],
        "isolated": "\uFEED",
        "final": "\uFEEE"
    },
    "alef_maksura": {
        "normal": [
            "\u0649"
        ],
        "hamza_above": [
            "\u0626",
            "\u064A\u0654"
        ],
        "initial": "\uFBE8",
        "medial": "\uFBE9",
        "isolated": "\uFEEF",
        "final": "\uFEF0"
    },
    "yeh": {
        "normal": [
            "\u064A"
        ],
        "hamza_above": {
            "normal": [
                "\u0626",
                "\u0649\u0654"
            ],
            "isolated": "\uFE89",
            "final": "\uFE8A",
            "initial": "\uFE8B",
            "medial": "\uFE8C"
        },
        "two_dots_below_hamza_above": [
            "\u08A8"
        ],
        "high_hamza": [
            "\u0678",
            "\u064A\u0674"
        ],
        "tail": [
            "\u06CD"
        ],
        "small_v": [
            "\u06CE"
        ],
        "three_dots_below": [
            "\u06D1"
        ],
        "two_dots_below_dot_above": [
            "\u08A9"
        ],
        "two_dots_below_small_noon_above": [
            "\u08BA"
        ],
        "isolated": "\uFEF1",
        "final": "\uFEF2",
        "initial": "\uFEF3",
        "medial": "\uFEF4"
    },
    "tteh": {
        "normal": [
            "\u0679"
        ],
        "isolated": "\uFB66",
        "final": "\uFB67",
        "initial": "\uFB68",
        "medial": "\uFB69"
    },
    "tteheh": {
        "normal": [
            "\u067A"
        ],
        "isolated": "\uFB5E",
        "final": "\uFB5F",
        "initial": "\uFB60",
        "medial": "\uFB61"
    },
    "beeh": {
        "normal": [
            "\u067B"
        ],
        "isolated": "\uFB52",
        "final": "\uFB53",
        "initial": "\uFB54",
        "medial": "\uFB55"
    },
    "peh": {
        "normal": [
            "\u067E"
        ],
        "small_meem_above": [
            "\u08B7"
        ],
        "isolated": "\uFB56",
        "final": "\uFB57",
        "initial": "\uFB58",
        "medial": "\uFB59"
    },
    "teheh": {
        "normal": [
            "\u067F"
        ],
        "isolated": "\uFB62",
        "final": "\uFB63",
        "initial": "\uFB64",
        "medial": "\uFB65"
    },
    "beheh": {
        "normal": [
            "\u0680"
        ],
        "isolated": "\uFB5A",
        "final": "\uFB5B",
        "initial": "\uFB5C",
        "medial": "\uFB5D"
    },
    "nyeh": {
        "normal": [
            "\u0683"
        ],
        "isolated": "\uFB76",
        "final": "\uFB77",
        "initial": "\uFB78",
        "medial": "\uFB79"
    },
    "dyeh": {
        "normal": [
            "\u0684"
        ],
        "isolated": "\uFB72",
        "final": "\uFB73",
        "initial": "\uFB74",
        "medial": "\uFB75"
    },
    "tcheh": {
        "normal": [
            "\u0686"
        ],
        "dot_above": [
            "\u06BF"
        ],
        "isolated": "\uFB7A",
        "final": "\uFB7B",
        "initial": "\uFB7C",
        "medial": "\uFB7D"
    },
    "tcheheh": {
        "normal": [
            "\u0687"
        ],
        "isolated": "\uFB7E",
        "final": "\uFB7F",
        "initial": "\uFB80",
        "medial": "\uFB81"
    },
    "ddal": {
        "normal": [
            "\u0688"
        ],
        "isolated": "\uFB88",
        "final": "\uFB89"
    },
    "dahal": {
        "normal": [
            "\u068C"
        ],
        "isolated": "\uFB84",
        "final": "\uFB85"
    },
    "ddahal": {
        "normal": [
            "\u068D"
        ],
        "isolated": "\uFB82",
        "final": "\uFB83"
    },
    "dul": {
        "normal": [
            "\u068F",
            "\u068E"
        ],
        "isolated": "\uFB86",
        "final": "\uFB87"
    },
    "rreh": {
        "normal": [
            "\u0691"
        ],
        "isolated": "\uFB8C",
        "final": "\uFB8D"
    },
    "jeh": {
        "normal": [
            "\u0698"
        ],
        "isolated": "\uFB8A",
        "final": "\uFB8B"
    },
    "veh": {
        "normal": [
            "\u06A4"
        ],
        "isolated": "\uFB6A",
        "final": "\uFB6B",
        "initial": "\uFB6C",
        "medial": "\uFB6D"
    },
    "peheh": {
        "normal": [
            "\u06A6"
        ],
        "isolated": "\uFB6E",
        "final": "\uFB6F",
        "initial": "\uFB70",
        "medial": "\uFB71"
    },
    "keheh": {
        "normal": [
            "\u06A9"
        ],
        "dot_above": [
            "\u0762"
        ],
        "three_dots_above": [
            "\u0763"
        ],
        "three_dots_pointing_upwards_below": [
            "\u0764"
        ],
        "isolated": "\uFB8E",
        "final": "\uFB8F",
        "initial": "\uFB90",
        "medial": "\uFB91"
    },
    "ng": {
        "normal": [
            "\u06AD"
        ],
        "isolated": "\uFBD3",
        "final": "\uFBD4",
        "initial": "\uFBD5",
        "medial": "\uFBD6"
    },
    "gaf": {
        "normal": [
            "\u06AF"
        ],
        "ring": [
            "\u06B0"
        ],
        "two_dots_below": [
            "\u06B2"
        ],
        "three_dots_above": [
            "\u06B4"
        ],
        "inverted_stroke": [
            "\u08B0"
        ],
        "isolated": "\uFB92",
        "final": "\uFB93",
        "initial": "\uFB94",
        "medial": "\uFB95"
    },
    "ngoeh": {
        "normal": [
            "\u06B1"
        ],
        "isolated": "\uFB9A",
        "final": "\uFB9B",
        "initial": "\uFB9C",
        "medial": "\uFB9D"
    },
    "gueh": {
        "normal": [
            "\u06B3"
        ],
        "isolated": "\uFB96",
        "final": "\uFB97",
        "initial": "\uFB98",
        "medial": "\uFB99"
    },
    "noon ghunna": {
        "normal": [
            "\u06BA"
        ],
        "isolated": "\uFB9E",
        "final": "\uFB9F"
    },
    "rnoon": {
        "normal": [
            "\u06BB"
        ],
        "isolated": "\uFBA0",
        "final": "\uFBA1",
        "initial": "\uFBA2",
        "medial": "\uFBA3"
    },
    "heh doachashmee": {
        "normal": [
            "\u06BE"
        ],
        "isolated": "\uFBAA",
        "final": "\uFBAB",
        "initial": "\uFBAC",
        "medial": "\uFBAD"
    },
    "heh goal": {
        "normal": [
            "\u06C1"
        ],
        "hamza_above": [
            "\u06C1\u0654",
            "\u06C2"
        ],
        "isolated": "\uFBA6",
        "final": "\uFBA7",
        "initial": "\uFBA8",
        "medial": "\uFBA9"
    },
    "teh marbuta goal": {
        "normal": [
            "\u06C3"
        ]
    },
    "kirghiz oe": {
        "normal": [
            "\u06C5"
        ],
        "isolated": "\uFBE0",
        "final": "\uFBE1"
    },
    "oe": {
        "normal": [
            "\u06C6"
        ],
        "isolated": "\uFBD9",
        "final": "\uFBDA"
    },
    "u": {
        "normal": [
            "\u06C7"
        ],
        "hamza_above": {
            "normal": [
                "\u0677",
                "\u06C7\u0674"
            ],
            "isolated": "\uFBDD"
        },
        "isolated": "\uFBD7",
        "final": "\uFBD8"
    },
    "yu": {
        "normal": [
            "\u06C8"
        ],
        "isolated": "\uFBDB",
        "final": "\uFBDC"
    },
    "kirghiz yu": {
        "normal": [
            "\u06C9"
        ],
        "isolated": "\uFBE2",
        "final": "\uFBE3"
    },
    "ve": {
        "normal": [
            "\u06CB"
        ],
        "isolated": "\uFBDE",
        "final": "\uFBDF"
    },
    "farsi yeh": {
        "normal": [
            "\u06CC"
        ],
        "indic_two_above": [
            "\u0775"
        ],
        "indic_three_above": [
            "\u0776"
        ],
        "indic_four_above": [
            "\u0777"
        ],
        "isolated": "\uFBFC",
        "final": "\uFBFD",
        "initial": "\uFBFE",
        "medial": "\uFBFF"
    },
    "e": {
        "normal": [
            "\u06D0"
        ],
        "isolated": "\uFBE4",
        "final": "\uFBE5",
        "initial": "\uFBE6",
        "medial": "\uFBE7"
    },
    "yeh barree": {
        "normal": [
            "\u06D2"
        ],
        "hamza_above": {
            "normal": [
                "\u06D2\u0654",
                "\u06D3"
            ],
            "isolated": "\uFBB0",
            "final": "\uFBB1"
        },
        "indic_two_above": [
            "\u077A"
        ],
        "indic_three_above": [
            "\u077B"
        ],
        "isolated": "\uFBAE",
        "final": "\uFBAF"
    },
    "ae": {
        "normal": [
            "\u06D5"
        ],
        "isolated": "\u06D5",
        "final": "\uFEEA",
        "yeh_above": {
            "normal": [
                "\u06C0",
                "\u06D5\u0654"
            ],
            "isolated": "\uFBA4",
            "final": "\uFBA5"
        }
    },
    "rohingya yeh": {
        "normal": [
            "\u08AC"
        ]
    },
    "low alef": {
        "normal": [
            "\u08AD"
        ]
    },
    "straight waw": {
        "normal": [
            "\u08B1"
        ]
    },
    "african feh": {
        "normal": [
            "\u08BB"
        ]
    },
    "african qaf": {
        "normal": [
            "\u08BC"
        ]
    },
    "african noon": {
        "normal": [
            "\u08BD"
        ]
    }
};
exports.default = arabicReference;
